import PropTypes from "prop-types";
import {Input} from "@material-ui/core";
import {useEffect} from "react";

function MetafieldNumber({change, metafield}) {

    const getDefaultValue = () => {
        return metafield.default;
    }

    useEffect(() => {
        if (metafield.default) {
            change(getDefaultValue())
        }
    }, []);

    return (
        <Input
            type={'number'}
            defaultValue={metafield.default}
            onChange={(e) => change(e.target.value)}
        />
    );
}

MetafieldNumber.propTypes = {
    change: PropTypes.func,
    metafield: PropTypes.object,
};

export default MetafieldNumber;